import React from "react";

import Hero from "../Components/Hero/Hero";
import WhoWeAre from "../Components/WhoWeAre/WhoWeAre";
import WhatWeOffer from "../Components/WhatWeOffer/WhatWeOffer";
import OurClients from "../Components/OurClients/OurClients";
import Empower from "../Components/Empower/Empower";
import Counter from "../Components/Counter/Counter";
import EnquiryForm from "../Components/EnquiryForm/EnquiryForm";
import ReviewsSection from "../Components/Reviews/ReviewsSection";

const Home = () => {
  return (
    <>
      <Hero />
      <WhoWeAre />
      <WhatWeOffer />
      <OurClients />
      <Empower />
      <Counter />
      <EnquiryForm />
      <ReviewsSection />
      {/* rest of sections... */}
    </>
  );
};

export default Home;
